export const adminAuditLogConstants = {
  GET_AUDIT_LOGS_REQUEST: "GET_AUDIT_LOGS_REQUEST",
  GET_AUDIT_LOGS_SUCCESS: "GET_AUDIT_LOGS_SUCCESS",
  SEARCH_BY_USERNAME_REQUEST: "SEARCH_BY_USERNAME_REQUEST",
  SEARCH_BY_USERNAME_SUCCESS: "SEARCH_BY_USERNAME_SUCCESS",
  CLEAR_AUDIT_LOGS: "CLEAR_AUDIT_LOGS",
};
